import React from 'react';

const clampStyle = (lines) => ({
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

const CARD_BORDER = '#ffedd5';
const CARD_HOVER_BORDER = '#fdba74';
const TITLE_HOVER = '#ea580c';
const BTN_GRADIENT = 'linear-gradient(to right, #f97316, #ea580c)';
const BTN_GRADIENT_HOVER = 'linear-gradient(to right, #ea580c, #c2410c)';

// Reusable media card used for both trending videos and spiritual playlists.
const MediaCard = ({
  meta,
  thumbnail,
  title,
  onClick,
  widthClassName = '',
  imageInteractive = true,
  imageAspect = '16/9', // '16/9' = aspect-video | 'fixed' = h-44
  overlayIcon,
  bottomLeftIcon = 'fas fa-clock',
  bottomLeftText,
  stats = [],
  description,
  button,
}) => {
  const handleMouseEnter = (e) => {
    e.currentTarget.style.borderColor = CARD_HOVER_BORDER;
    const titleEl = e.currentTarget.querySelector('h3');
    if (titleEl) titleEl.style.color = TITLE_HOVER;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.borderColor = CARD_BORDER;
    const titleEl = e.currentTarget.querySelector('h3');
    if (titleEl) titleEl.style.color = '';
  };

  const imgSizeClass = imageAspect === 'fixed' ? 'w-full h-44' : 'w-full aspect-video';
  const imageClassName = `${imgSizeClass} object-cover group-hover:scale-105 transition-transform duration-300${imageInteractive ? '' : ' pointer-events-none'}`;

  return (
    <div
      onClick={onClick}
      className={`group flex flex-col ${widthClassName} border rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer hover:-translate-y-1`}
      style={{
        background: 'linear-gradient(to bottom right, #ffffff, #fff7ed)',
        borderColor: CARD_BORDER,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="relative overflow-hidden">
        <img
          src={thumbnail || '/logo.jpg'}
          alt={title}
          draggable={imageInteractive ? undefined : false}
          className={imageClassName}
          onError={(e) => { if (e.target.src !== window.location.origin + '/logo.jpg') e.target.src = '/logo.jpg'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>

        {/* Play Button Overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
          <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full w-14 h-14 flex items-center justify-center transform scale-75 group-hover:scale-100 transition-all duration-300">
            <div
              className="rounded-full w-10 h-10 flex items-center justify-center shadow-xl"
              style={{ background: BTN_GRADIENT }}
            >
              <i className={`${overlayIcon} text-white text-lg`}></i>
            </div>
          </div>
        </div>

        {/* Category Badge — hidden */}

        {/* Bottom Badge (duration / hours) */}
        {bottomLeftText && (
        <div className="absolute bottom-2 left-2 right-2 flex justify-between items-center text-white">
          <div className="bg-black bg-opacity-60 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-medium">
            <i className={`${bottomLeftIcon} mr-1`}></i>{bottomLeftText}
          </div>
        </div>
        )}
      </div>

      {/* Card Content — same for all cards */}
      <div className="p-4 flex flex-col flex-1">
        <h3
          className="font-semibold text-base text-gray-800 mb-2 transition-colors leading-tight"
          style={clampStyle(2)}
        >
          {title}
        </h3>
        <div className="flex items-center justify-between mb-3 text-xs text-gray-600">
          {stats.map((stat, idx) => (
            <div className="flex items-center" key={idx}>
              <i
                className={`${stat.icon} mr-1 ${stat.className || ''}`}
                style={stat.accent ? { color: '#f97316' } : undefined}
              ></i>
              <span>{stat.text}</span>
            </div>
          ))}
        </div>
        {description && (
          <p className="text-gray-600 text-xs mb-3 leading-relaxed" style={clampStyle(3)}>
            {description}
          </p>
        )}
        <button
          className={`w-full mt-auto text-white ${button.className} transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105`}
          style={{ background: BTN_GRADIENT }}
          onMouseEnter={(e) => { e.currentTarget.style.background = BTN_GRADIENT_HOVER; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = BTN_GRADIENT; }}
        >
          <i className={`${button.icon} mr-2`}></i>{button.label}
        </button>
      </div>
    </div>
  );
};

export default MediaCard;
